<quill-editor
  [modules]="quillConfig.modules"
  [placeholder]="quillConfig.placeholder"
  [(ngModel)]="editorData"
  (onEditorCreated)="setEditor($event)"
  (onContentChanged)="setValue($event)"
></quill-editor>
